(function($, duo, undefined){

	"use strict";

	/**
	 * @class SmoothScroll
	 */
	class SmoothScroll {

		/**
		 * Creates an instance of SmoothScroll -
		 * using the contructor will add smooth scroll functionality to all links provided in the selector
		 * @param selector css selector of the element to attach click handler to
		 * @param scrollSpeed length of the scroll animation (in milliseconds)
		 * @param useConstantScrollSpeed defaults to false
		 * @param scrollAccelerator base speed (in milliseconds) divided by a base length, used if useConstantScrollSpeed is set to true
		 */
		constructor({selector = 'a[href*="#"]:not([href="#"])', scrollSpeed = 1000, useConstantScrollSpeed = false, scrollAccelerator = (60/100) } = {}) {
			this.selector = selector;

			this.scrollSpeed = scrollSpeed;
			this.useConstantScrollSpeed = useConstantScrollSpeed;
			this.scrollAccelerator = scrollAccelerator;

			// setup click event handler:
			this._setEventHandlers();
		} /* constructor */

		/**
		 * Setup click handler for smooth scroll links
		 */
		_setEventHandlers() {
			const smoothscroll = this;

			$(document).on('click.SmoothScroll', smoothscroll.selector, function(e) {
				if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

					if (target.length) {
						duo.SmoothScroll._doScroll(target, { 
							scrollSpeed: smoothscroll.scrollSpeed, 
							useConstantScrollSpeed: smoothscroll.useConstantScrollSpeed, 
							scrollAccelerator: smoothscroll.scrollAccelerator
						});
						return false;
					}

				}
			});
		} /* _setEventHandlers */

		/**
		 * Static function to scroll to an element on the page
		 */
		static scrollTo($scrollTargetElement, { scrollSpeed = 1000, useConstantScrollSpeed = false, scrollAccelerator = (60/100) } = {}) {
			this._doScroll($scrollTargetElement, { scrollSpeed, useConstantScrollSpeed, scrollAccelerator });
		}

		/**
		 * Private scroll function
		 */
		static _doScroll($scrollTargetElement, { scrollSpeed = 1000, useConstantScrollSpeed = false, scrollAccelerator = (60/100) } = {}) {
			const scrollOffset = $scrollTargetElement.offset().top;

			// calculate scroll speed:
			if(useConstantScrollSpeed && scrollAccelerator !== undefined) {
				const currentScrollOffset = $(window).scrollTop();
				const heightDifference = Math.abs(currentScrollOffset - scrollOffset);
				scrollSpeed = Math.round(heightDifference * scrollAccelerator);
			}

			$('html, body').on('mousedown wheel DOMMouseScroll mousewheel touchmove', function(){
				$('html, body').stop();
			});

			$('html, body').animate({
				scrollTop: scrollOffset
			}, scrollSpeed, function() {
				$('html, body').off('mousedown wheel DOMMouseScroll mousewheel touchmove');

				// focus the target element:
				$scrollTargetElement.focus();
				if ($scrollTargetElement.is(":focus")) { 
					return false;
				} else {
					$scrollTargetElement.attr('tabindex','-1');
					$scrollTargetElement.focus();
				}
			});
		} /* _doScroll */

	} /* SmoothScroll */

	duo.SmoothScroll = SmoothScroll;

})(jQuery, window.duo = window.duo || {});
